var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBtnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5215 0L23.001 6.62772L21.5069 9.2156L10.0274 2.58788L11.5215 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.71289V19.9683H20.0118V6.71289H23Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9785 19.9453L11.499 26.573L10.0048 23.9852L21.4844 17.3574L22.9785 19.9453Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4805 0L0.000912338 6.62772L1.49502 9.2156L12.9746 2.58788L11.4805 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.71289L0 19.9683H2.98822L2.98822 6.71289H0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0214844 19.9453L11.501 26.573L12.9952 23.9852L1.5156 17.3574L0.0214844 19.9453Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 1.97266L10.0039 15.2281H12.9921L12.9921 1.97266L10.0039 1.97266Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01758 18.7803L11.4904 21.94L12.9845 19.3521L8.91247 17.0011L6.01758 18.7803Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.9395L16.9728 18.7797L15.4787 16.1919L10.0059 19.3516L11.5 21.9395Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 6.03613L13.9922 18.7503H16.9638V7.64168L13.9922 6.03613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnLogo);
export default __webpack_public_path__ + "static/media/ic_btn_logo.95114d0bc7cd12764678d9c5a28cdac1.svg";
export { ForwardRef as ReactComponent };